$shm_dashboard_admin_monitoring $mol_page
	title \Мониторинг упоминаний
	head /
		<= Head $shm_list_head
			title \Мониторинг упоминаний
			filter? <=> filter? \
			add_content /
			Close null
	body /
		<= Controls $mol_view
			sub /
				<= Day_title $mol_view
					sub / \День запусков
				<= Day_prev $mol_button_minor
					hint \Предыдущий день
					click? <=> day_prev? null
					sub /
						<= Day_prev_icon $mol_icon_chevron_left
				<= Day $mol_date
					value? <=> day? \
					trigger_content /
						<= Day_value $mol_view
							sub / <= day_display \
				<= Day_next $mol_button_minor
					hint \Следующий день
					enabled <= day_next_enabled true
					click? <=> day_next? null
					sub /
						<= Day_next_icon $mol_icon_chevron_right
				<= Day_latest $mol_button_minor
					title \Последний день
					click? <=> day_latest? null
		<= Summary $mol_view
			sub /
				<= Enabled $shm_ba_summary_card
					title \Задач всего (tasks)
					value <= enabled_count \
				<= Running $shm_ba_summary_card
					title \Сейчас выполняется (jobs)
					value <= running_count \
					style *
						^
						color <= running_color \
				<= Completed $shm_ba_summary_card
					title \Выполнено за день (jobs)
					value <= completed_count \
					style *
						^
						color <= completed_color \
				<= Errors $shm_ba_summary_card
					title \С ошибками
					value <= error_count \
					style *
						^
						color <= error_count_color \
				<= Outdated $shm_ba_summary_card
					title \Расхождение с письмом
					value <= outdated_count \
					style *
						^
						color <= outdated_color \
		<= Problems $mol_view
			sub /
				<= Problems_title $mol_view
					sub / <= problems_title \
					style *
						^
						color <= problems_color \
				<= Problem_rows $mol_list
					rows <= problem_rows /
		<= Table $mol_view
			sub /
				<= Table_head $mol_view
					sub /
						<= Head_dashboard $mol_view
							sub / \Дашборд
						<= Head_file $mol_view
							sub / \Файл
						<= Head_client $mol_view
							sub / \Клиент
						<= Head_period $mol_view
							sub / \Период
						<= Head_ba_id $mol_view
							sub / \ba_subscriber_id
						<= Head_state $mol_view
							sub / \Состояние
						<= Head_dates $mol_view
							sub / \Даты данных
						<= Head_time $mol_view
							sub / \Время этапов
						<= Head_error $mol_view
							sub / \Ошибка / предупреждение
				<= Rows $mol_list
					rows <= task_rows /
		<= Empty $mol_view
			sub / <= empty_text \
	Problem* $mol_button_minor
		title <= problem_title* \
		click? <=> problem_open*? null
	Row* $mol_view
		sub /
			<= Dashboard_cell* $mol_view
				sub / <= dashboard_title* \
			<= File* $mol_view
				sub / <= file_title* \
			<= Client* $mol_view
				sub / <= client_title* \
			<= Period* $mol_view
				sub / <= period_title* \
			<= Ba_id* $mol_view
				sub / <= ba_id_title* \
			<= State* $mol_view
				sub / <= state_title* \
				style *
					^
					color <= state_color* \
			<= Dates* $mol_view
				sub / <= dates_text* \
			<= Time* $mol_view
				sub / <= time_text* \
			<= Error* $mol_text
				text <= error_text* \
				style *
					^
					color <= error_color* \
